<div (window:resize)="onResize($event)" [ngClass]="!mobileClicked ? 'closed-nav' : 'opened-nav'" class="navigation">
  <div class="navigation__logo">
    <a routerLink="/">
      <img src="../../assets/images/Strowr-ultra dark.svg" />
    </a>
  </div>
  <div class="row flex-nowrap navigation__content nopadding">
    <!-- <div class="col-auto nopadding">
      <div class="organizations-sidebar__container">
        <app-organizations-sidebar></app-organizations-sidebar>
      </div>
    </div> -->
    <div class="col navigation__menu__right nopadding">
      <div class="navigation__menu">
        <ul class="navigation__nav">
          <li>
            <div class="navigation__nav__icon__wrap">
              <span class="icon icon--experience"></span><a (click)="openMenu(1); (false)" href="#"
                translate>Experiences</a>
            </div>
            <ul [ngClass]="dropdownNumber == 1 ? 'active--drop' : ' '" class="navigation__menu__dropdown"
              (click)="backgroundClose()">
              <li>
                <a routerLink="/active" routerLinkActive="active"><span translate>Active</span> ({{
                  counter?.activeVersionsCount ?? 0
                  }})
                </a>
              </li>
              <li>
                <a routerLink="/expired" routerLinkActive="active"><span translate>Expired</span> ({{
                  counter?.expiredVersionsCount ?? 0
                  }})
                </a>
              </li>
              <li>
                <a routerLink="/pendingApproval" routerLinkActive="active"><span translate>Pending approval</span> ({{
                  counter?.pendingVersionsCount ?? 0
                  }})</a>
              </li>
              <li>
                <a routerLink="/drafts" routerLinkActive="active"><span translate>Drafts</span> ({{
                  counter?.draftVersionsCount ?? 0
                  }})</a>
              </li>
              <li>
                <a routerLink="/rejected" routerLinkActive="active"><span translate>Rejected</span> ({{
                  counter?.rejectedVersionsCount ?? 0
                  }})</a>
              </li>
              <li>
                <a routerLink="/bin" routerLinkActive="active"><span translate>Bin</span></a>
              </li>
            </ul>
          </li>
          <!-- <li class="">
            <div class="navigation__nav__icon__wrap">
              <span class="icon icon--settings"></span>
              <a routerLink="/settings" routerLinkActive="active" translate
                >Settings</a
              >
            </div>
          </li>
          <li class="">
            <div class="navigation__nav__icon__wrap">
              <span class="icon icon--members"></span>
              <a routerLink="members" routerLinkActive="active" translate
                >Members</a
              >
            </div>
          </li>
          <li class="">
            <div class="navigation__nav__icon__wrap">
              <span class="icon icon--qr"></span>
              <a routerLink="qr-codes" routerLinkActive="active" translate
                >QR codes</a
              >
            </div>
          </li> -->

          <li>
            <div class="navigation__nav__icon__wrap">
              <span class="icon icon--noicon"></span><a (click)="openMenu(2); (false)" href="#" translate>Languages</a>
            </div>
            <ul [ngClass]="dropdownNumber == 2 ? 'active--drop' : ' '" class="navigation__menu__dropdown"
              (click)="backgroundClose()">
              <li (click)="useLanguage('en')">
                <a (click)="(false)" href="#" routerLinkActive="active" translate>English</a>
              </li>
              <li (click)="useLanguage('bg')">
                <a (click)="(false)" href="#" routerLinkActive="active" translate>Bulgarian</a>
              </li>
            </ul>
          </li>

          <!--<li><a (click)="openMenu(2); false" href="#">Members</a>
                <ul [ngClass]="dropdownNumber == 2 ? 'active--drop': ' '" class="navigation__menu__dropdown">
                    <li>
                        <a href="#">Active (4)</a>
                    </li>
                </ul>
            </li>-->
          <li class="mobile__logout">
            <span class="icon icon--noicon"></span>
            <a (click)="logOut(); (false)" href="#" translate>Logout</a>
          </li>
        </ul>
      </div>

      <div class="navigation__footer"></div>
    </div>
  </div>
</div>